export const messages = {
    requiredField: 'فیلد الزامی است',
    invalidEmailFormat: 'لطفا یک ایمیل معتبر وارد کنید',
    invalidMobileFormat: 'لطفا یک شماره تلفن همراه معتبر وارد کنید',
    passwordMinLength: 'رمز عبور باید حداقل 8 حرف باشد' 
}